import { theme, Typography } from '@notino/react-styleguide';

import { css } from '@linaria/core';

export const noScrollbarCss = `
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Edge */
  scrollbar-width: none; /* Firefox */
`;

export const elipsis = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const typographyClass: Typography = {
  titleDisplay: css`
    ${theme.typography.titleDisplay}
  `,
  titleLarge: css`
    ${theme.typography.titleLarge}
  `,
  titleMedium: css`
    ${theme.typography.titleMedium}
  `,
  titleSmall: css`
    ${theme.typography.titleSmall}
  `,
  bodyLarge: css`
    ${theme.typography.bodyLarge}
  `,
  bodyRegular: css`
    ${theme.typography.bodyRegular}
  `,
  bodySmall: css`
    ${theme.typography.bodySmall}
  `,
  labelLarge: css`
    ${theme.typography.labelLarge}
  `,
  labelLarge400: css`
    ${theme.typography.labelLarge400}
  `,
  labelRegular: css`
    ${theme.typography.labelRegular}
  `,
  labelRegular400: css`
    ${theme.typography.labelRegular400}
  `,
  labelSmall: css`
    ${theme.typography.labelSmall}
  `,
  labelSmall400: css`
    ${theme.typography.labelSmall400}
  `,
  labelButton: css`
    ${theme.typography.labelButton}
  `,
};
